import { render } from "./Book.vue?vue&type=template&id=49e17e90"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
script.render = render

export default script